<template>
  <div class="comment-module">
    <ul
      v-if="comment.list && comment.list.length"
      class="list-box"
    >
      <li
        v-for="(item, index) in comment.list"
        :key="item.id"
      >
        <div class="top">
          <span class="time">{{ moment(item.addtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}</span>
          <span class="name">{{ item.truename }}</span>
          <a
            v-if="permissionInfo.is_del_comments"
            class="del-btn fs-blue fr"
            @click="handleDeleteComment(item.id)"
          >{{ $t('message["962"]') }}</a>
        </div>
        <div class="content">
          {{ item.content }}
        </div>
        <!-- 新增评论操作按钮 -->
        <div
          v-if="permissionInfo.is_add_comments"
          class="operate-btns"
        >
          <span
            class="mesage"
            @click="handleReply(item, index)"
          >
            <i class="iconfont iconcomment" />{{ (item.replys && item.replys.length) || $t('message["449"]') }}
          </span>
        </div>
      </li>
    </ul>
    <div
      v-else
      class="fs-gray list-empty"
    >
      <div
        v-if="permissionInfo.is_add_comments"
        class="add-btn"
        @click="openCommentModal"
      >
        <span class="left">{{ $t('message["1351"]') }}</span>
        <i class="iconfont iconicon-test18 arrow" />
      </div>
      <p v-else>
        {{ $t('message["1552"]') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import eventBus from '@/lib/eventBus'
import moment from 'moment'

export default {
  components: {

  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState('inquery/detailData', ['comment']),
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    commentid () {
      return this.$route.query.commentid
    },
    replyid () {
      return this.$route.query.replyid
    }
  },
  async created () {
    eventBus.$on('getCommentList', this.getCommentList)
    await this.getCommentList()
  },
  methods: {
    moment,
    ...mapActions('inquery/detailData', [
      'fetchCommentList',
      'inquiryAddComment',
      'inquiryDelComment'
    ]),
    async getCommentList () {
      const chain = await this.fetchCommentList()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .onSuccess(res => {
          if (this.comment.list && this.comment.list.length) {
            let id = 'commentLi' + this.commentid
            let $currCommentLi = document.getElementById(id)
            setTimeout(() => {
              // console.log($currCommentLi)
              $currCommentLi && $currCommentLi.scrollIntoView(false)
            }, 30)
          }
        })
        .fetch()
    },
    openCommentModal () {
      // this.showAddCommentModal = true
      eventBus.$emit('openCommentModal')
    },
    handleReply (item, index) {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'commentReply',
          commentid: item.id
        }
      })
    },
    handleDeleteComment (commentid) {
      let content = this.$t('message["1887"]') // 一旦删除，无法恢复，|是否继续？
      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        title: this.$t('message["1890"]'), // '将删除该条评论及回复'
        content,
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.$t('message["896"]'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: async () => {
          const chain = await this.inquiryDelComment({ inquiryid: this.inquiryId, commentid: commentid })
          chain
            .onSuccess(res => {
              this.getCommentList()
            })
        }
      }).show()
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-module {
  .add-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin: 12px 0;
    width: 100%;
    height: 24px;
    line-height: 24px;
    // padding: 16px 12px;
    background-color: #fff;
    .left {
      display: flex;
      color: #5077aa;
      .iconfont {
        display: none;
        margin-right: 8px;
        color: #42c27e;
        font-size: 24px;
      }
    }
    .iconfont.arrow {
      color: #ccc;
      font-size: 16px;
    }
  }
  .list-box {
    margin-bottom: 0;
    background-color: #fff;

    li {
      margin: 0 12px;
      padding: 16px 0;
      line-height: 1;
      border-bottom: solid 1px $gray4;
      &:last-child {
        border: none;
      }
    }
    .top {
      margin-bottom: 12px;
      font-size: 16px;
      color: #333;
    }
    .name {
      margin: 0 32px;
      font-size: 16px;
    }
    .content {
      line-height: 24px;
      color: $gray2;
      font-size: 16px;
      word-break: break-all;
    }
  }

  .list-empty {
    padding: 16px 12px;
    line-height: 24px;
    color: #d6d6d6;
    font-size: 16px;
    background: #fff;
  }
  .operate-btns {
    height: 32px;
    line-height: 32px;
    margin-top: 12px;
    text-align: right;
    color: #d6d6d6;
    .iconfont {
      margin-right: 5px;
    }
  }
}
</style>
